import { CeresFeaturesConfig } from './interfaces/ceres-features-config.interface';

export interface RawFeatureProfiles {
    tenantFeatures: Record<string, { enabled: boolean }>;
    releaseFlags: Record<string, { enabled: boolean }>;
}

export function mergeFlatFlagsIntoFeatures(
    base: CeresFeaturesConfig,
    raw: RawFeatureProfiles,
    onUnmatched: (path: string) => void = () => undefined
): CeresFeaturesConfig {
    const merged = structuredClone(base);

    for (const [path, flag] of Object.entries({ ...raw.tenantFeatures, ...raw.releaseFlags })) {
        const keys = path.split('.');
        const leaf = keys.pop();
        let parent: unknown = merged;

        for (const key of keys) {
            if (typeof parent !== 'object' || parent === null || !Object.prototype.hasOwnProperty.call(parent, key)) {
                parent = undefined;
                break;
            }
            parent = (parent as Record<string, unknown>)[key];
        }

        if (
            leaf !== undefined &&
            typeof parent === 'object' &&
            parent !== null &&
            Object.prototype.hasOwnProperty.call(parent, leaf) &&
            typeof (parent as Record<string, unknown>)[leaf] === 'boolean'
        ) {
            (parent as Record<string, unknown>)[leaf] = flag.enabled;
        } else {
            onUnmatched(path);
        }
    }

    return merged;
}
